import { render, staticRenderFns } from "./managerNoticeModal.vue?vue&type=template&id=63928354&scoped=true&"
import script from "./managerNoticeModal.vue?vue&type=script&lang=js&"
export * from "./managerNoticeModal.vue?vue&type=script&lang=js&"
import style0 from "./managerNoticeModal.vue?vue&type=style&index=0&id=63928354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63928354",
  null
  
)

export default component.exports